function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g fill="none" fillRule="evenodd"><circle cx="12" cy="12" r="12" fill="#FF8669" /><path fill="#FFF" fillRule="nonzero" stroke="#FFF" strokeWidth=".5" d="M10 14.057l6.862-6.862a.667.667 0 0 1 .943.943l-7.334 7.333a.667.667 0 0 1-.942 0l-3.334-3.333a.667.667 0 1 1 .943-.943L10 14.057z" /></g></svg>;
});